export default "/images/team-spirit.png?f12a43e86392213ec46877ae26c085f3";